import { useCallback } from "react";

import { usePerson } from "@/shared/hooks/useAppContext";
import { useSaveSSN } from "@/shared/hooks/useSaveSSN";

import { saveBenefitsData, saveMilitaryDetails } from "../utils/formSubmitHelpers";

export function useSaveBenefitsFields(
  moduleId: string | undefined,
  deceasedUserId: number | undefined,
) {
  const person = usePerson();
  const { saveSSN: saveDeceasedSSN } = useSaveSSN();

  return useCallback(
    async (data: Record<string, string>) => {
      const isBenefitsModule =
        moduleId === "social-security-benefits" || moduleId === "veterans-survivor-benefits";

      if (isBenefitsModule && deceasedUserId) {
        await saveBenefitsData(data, deceasedUserId, saveDeceasedSSN);
      }

      if (moduleId === "veterans-survivor-benefits" && person?.estate_id) {
        await saveMilitaryDetails(data, person.estate_id);
      }
    },
    [moduleId, deceasedUserId, person?.estate_id, saveDeceasedSSN],
  );
}
